<template>
    <transition name="modal">
        <div v-if="element && !isLoading" class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="container">
                        <div class="modal-header">
                            <div class="row">
                                <div class="col-8">
                                    <h1 v-text="element.$exists ? 'Edit Company' : 'Add Company'"></h1>
                                </div>
                                <div class="col-auto ml-auto">
                                    <div aria-label="Close modal window" class="modal-default-button fa fa-window-close d-print-none" @click="$emit('close')"></div>
                                </div>
                            </div>
                        </div>

                        <div class="modal-body">
                            <div class="row mb-5">
                                <div class="col-md">
                                    <h6 class="h6">Name <span class="required">*</span></h6>
                                    <input class="form-control" type="text" v-model="element.name">
                                    <div class="alert alert-danger" v-if="errors && 'name' in errors" v-text="errors.name.join()"></div>
                                </div>
                            </div>

                            <div class="row mb-4">
                                <div class="col-md">
                                    <div class="form-group">
                                        <h6 class="h6">Company Can Set Delivery Days</h6>
                                        <div class="form-check-inline">
                                            <label class="form-check-label">
                                                <input class="form-check-input" type="radio" value="1" v-model="element.can_set_delivery_days"> Yes
                                            </label>
                                        </div>

                                        <div class="form-check-inline">
                                            <label class="form-check-label">
                                                <input class="form-check-input" type="radio" value="0" v-model="element.can_set_delivery_days"> No
                                            </label>
                                        </div>
                                        <div class="alert alert-danger" v-if="errors && 'can_set_delivery_days' in errors" v-text="errors.can_set_delivery_days.join()"></div>
                                    </div>
                                </div>
                                <div class="col-md">
                                    <div class="form-group">
                                        <h6 class="h6">Company Can Set Price</h6>
                                        <div class="form-check-inline">
                                            <label class="form-check-label">
                                                <input class="form-check-input" type="radio" value="1" v-model="element.can_set_price"> Yes
                                            </label>
                                        </div>

                                        <div class="form-check-inline">
                                            <label class="form-check-label">
                                                <input class="form-check-input" type="radio" value="0" v-model="element.can_set_price"> No
                                            </label>
                                        </div>
                                        <div class="alert alert-danger" v-if="errors && 'can_set_price' in errors" v-text="errors.can_set_price.join()"></div>
                                    </div>
                                </div>
                                <div class="col-md">
                                    <div class="form-group">
                                        <h6 class="h6">Company Can Set Emergency Fee</h6>
                                        <div class="form-check-inline">
                                            <label class="form-check-label">
                                                <input class="form-check-input" type="radio" value="1" v-model="element.can_set_emergency_delivery_price"> Yes
                                            </label>
                                        </div>

                                        <div class="form-check form-check-inline">
                                            <label class="form-check-label">
                                                <input class="form-check-input" type="radio" value="0" v-model="element.can_set_emergency_delivery_price"> No
                                            </label>
                                        </div>
                                        <div class="alert alert-danger" v-if="errors && 'can_set_emergency_delivery_price' in errors" v-text="errors.can_set_emergency_delivery_price.join()"></div>
                                    </div>
                                </div>
                                <div class="col-md">
                                    <div class="form-group">
                                        <h6 class="h6">Company Can See emails</h6>
                                        <div class="form-check-inline">
                                            <label class="form-check-label">
                                                <input class="form-check-input" type="radio" value="1" v-model="element.can_see_emails"> Yes
                                            </label>
                                        </div>

                                        <div class="form-check form-check-inline">
                                            <label class="form-check-label">
                                                <input class="form-check-input" type="radio" value="0" v-model="element.can_see_emails"> No
                                            </label>
                                        </div>
                                        <div class="alert alert-danger" v-if="errors && 'can_see_emails' in errors" v-text="errors.can_see_emails.join()"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-5">
                                <div class="col-md">
                                    <h6 class="h6">Tank Inspection Notice Message</h6>
                                    <textarea class="form-control" v-model="element.inspection_notice_message"></textarea>
                                    <div class="alert alert-danger" v-if="errors && 'inspection_notice_message' in errors" v-text="errors.inspection_notice_message.join()"></div>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-md">
                                    <h6 class="h6">Members</h6>

                                    <div class="alert alert-danger" v-if="errors && 'adding_members' in errors" v-text="errors.adding_members.join()"></div>

                                    <company-members v-if="companyParams.company" v-slot="{ companyMembers }" :params="companyParams">
                                        <div v-if="companyMembers" class="table-responsive">
                                            <table class="table table-sm table-striped mt-0">
                                                <tr v-for="member in companyMembers" :key="member.id">
                                                    <td v-text="`${member.name} (${member.email})`"></td>
                                                    <td class="actions">
                                                        <button class="btn btn-sm btn-link" @click="detachMember(member)">Remove</button>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </company-members>

                                    <div v-if="element.$exists">
                                        <div class="table-responsive">
                                            <table class="table table-sm mt-0">
                                                <tr>
                                                    <td class="border-0">
                                                        <input class="form-control form-control-sm" type="text" v-model="newMemberEmail" placeholder="Add user by email">
                                                    </td>
                                                    <td class="actions border-0">
                                                        <button class="btn btn-sm btn-link" @click="attachMember()">Add User</button>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    <div v-else class="alert alert-info">
                                        After saving the element, you can add members.
                                    </div>
                                </div>
                            </div>

                            <div class="alert alert-danger" v-if="errors && 'general' in errors" v-text="errors.general.join()"></div>

                            <div class="d-flex justify-content-between d-print-none">
                                <div>
                                    <delete-button @confirmed="destroyAndClose(element)" title="Delete Company">
                                        <p>
                                            Are you sure you want to delete the company {{ element.name }}?
                                        </p>
                                    </delete-button>
                                </div>
                                <div class="ml-auto">
                                    <button aria-label="Close Company Modal window" class="btn btn-medium" @click="$emit('close')">Cancel</button>

                                    <button class="btn btn-primary" @click="saveAndClose(element)" v-text="element.$exists ? 'Update' : 'Save'"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    </transition>
</template>

<script>
import { ContinuousCollectionComponent, ElementComponent } from 'clockvine-vue';
import deleteButton from './DeleteButton';
import ElementOperations from './helpers/ElementOperations';

export default {
    props: ['id'],
    components: {
        deleteButton,
        companyMembers: ContinuousCollectionComponent.for('companyMembers'),
    },

    mixins: [
        ElementComponent.for("companies").with({
            computed: {
                newElement: () => ({
                    name: '',
                    can_set_delivery_days: 0,
                    can_set_price: 0,
                    can_set_emergency_delivery_price: 0,
                    can_see_emails: 0,
                    inspection_notice_message: '',
                })
            }
        }),
        ElementOperations
    ],

    data: () => ({
        newMemberEmail: '',
        companyParams: {company: null},
    }),

    methods: {
        saveAndClose() {
            this.save().then(() => {
                this.$emit('close');
            })
        },

        destroyAndClose() {
            this.delete().then(() => {
                this.$emit('close');
            })
        },

        attachMember() {
            this.$store.dispatch('companyMembers/store', {data:{email: this.newMemberEmail, company: this.id}, urlParams: {company: this.id}})
                .then(() => {
                    this.newMemberEmail = '';
                })
                .catch(this.handleErrors);
        },
        
        detachMember(member) {
            member.$destroy();
        },
    },

    mounted() {
        this.companyParams.company = this.id;
    },


    // mounted() {
    //     if (this.id) {
    //         let company = this.id;
    //         this.$store.dispatch('companyMembers/index', {urlParams: {company}});
    //     }
    // },
}
</script>
